import http from '@/utils/http';
const base_path = '/v2/channelInterface/advertiser';

/**
 * 获取渠道接口类型下的广告商接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const getChannelInterfaceAdvertiserApi = (params) => {
  return http.get({
    url: `${base_path}/selector`,
    params,
  });
};
